<ul
  *ngIf="searchData && searchValue.length > 1 && !noResult"
  class="ui-autocomplete ui-front ui-menu ui-widget ui-widget-content"
  id="ui-id-1"
  tabindex="0"
>
  <!-- <table class="ui-menu-item" id="ui-id-2" tabindex="-1" *ngIf="showNow">
    <thead>
      <tr>
        <ng-container *ngFor="let key of SortOrder">
          <th
            *ngIf="
              key === 'APN' ||
              key === 'Layer' ||
              key === 'Situs address' ||
              key === 'Owner name'
            "
          >
            {{ key }}
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr
        class="ui-menu-item"
        *ngFor="let data of searchData"
        (click)="getSearchDetails(data)"
      >
        <ng-container *ngFor="let key of SortOrder; index as i">
          <ng-container
            *ngIf="
              key === 'APN' ||
              key === 'Layer' ||
              key === 'Situs address' ||
              key === 'Owner name'
            "
          >
            <td class="whitespace" *ngIf="data[key]">
              {{ data[key] }}
            </td>
            <td class="whitespace" *ngIf="!data[key]">null</td>
          </ng-container>
        </ng-container>
      </tr>
    </tbody>
  </table> -->


  <table  class="ui-menu-item" id="ui-id-2" tabindex="-1" *ngIf="showNow">
    <ng-container *ngFor="let panel of searchData">
    <thead>
      <tr>
        <th *ngFor="let header of panel.header">{{ header }}</th>
      </tr>
    </thead>
    <tbody>
      <tr  class="ui-menu-item" *ngFor="let layer of panel.features" (click)="getSearchDetails(layer)">
        <td *ngFor="let col of panel.header">
          <span style="  float: left;text-align: initial;">
            {{ layer[col] }}
          </span>
        </td>
        <!-- <td class="whitespace" *ngFor="let value of layer | keyvalue">{{ value.value }}</td> -->
      </tr>
    </tbody>
  </ng-container>
  </table>

</ul>

<ul
  *ngIf="noResult && searchValue.length"
  class="ui-autocomplete ui-front ui-menu ui-widget ui-widget-content"
  id="ui-id-2"
  tabindex="0"
  style="
    display: block;
    width: 640px;
    left: 599px;
    right: 0px;
    height: max-content;
    overflow: hidden auto;
    z-index: 999;
    font-family: arial !important;
    color: black !important;
  "
>
  <table class="ui-menu-item" id="ui-id-2" tabindex="-1">
    <tbody>
      <tr>
        <td>No Search Result Found.</td>
      </tr>
    </tbody>
  </table>
</ul>
